import { createBrowserRouter, Navigate, type RouteObject } from "react-router-dom";
import { RootLayout } from "./layout/RootLayout";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { LoginPage } from "./pages/Login";

import { OverviewPage } from "./pages/Overview";
import { ProjectsPage } from "./pages/Projects";
import { ProjectDetailPage } from "./pages/ProjectDetail";
import { ServicesPage } from "./pages/Services";
import { ServiceDetailPage } from "./pages/ServiceDetail";
import { AddServiceWizardPage } from "./pages/AddServiceWizard/AddServiceWizard";
import { DeploymentsPage } from "./pages/Deployments";
import { ContainersPage } from "./pages/Containers";
import { ServiceMapPage } from "./pages/ServiceMap";
import { TracingPage } from "./pages/Tracing";
import { TraceDetailPage } from "./pages/TraceDetail";
import { LogsPage } from "./pages/Logs";
import { MetricsPage } from "./pages/Metrics";
import { RCAPage } from "./pages/RCA";
import { DependenciesPage } from "./pages/Dependencies";
import { HealthPage } from "./pages/Health";
import { AIAssistantPage } from "./pages/AIAssistant";
import { AlertsPage } from "./pages/Alerts";
import { SecurityPage } from "./pages/Security";
import { ProfilingPage } from "./pages/Profiling";
import { TestingPage } from "./pages/Testing";
import { ExportPage } from "./pages/Export";
import { ClusterTopologyPage } from "./pages/ClusterTopology";
import { ClusterOverviewPage } from "./pages/ClusterOverview";
import { K8sExplorerPage } from "./pages/K8sExplorer";
import { ContainerDetailPage } from "./pages/ContainerDetail";
import { OperationsWorkspacePage } from "./pages/OperationsWorkspace";
import { DeploymentViewerPage } from "./pages/DeploymentViewerPage";
import { NotFoundPage } from "./pages/NotFound";

// Exported for CoreMonit host mount (see docs/integration.md).
export const microservicesRoutes: RouteObject[] = [
  { index: true, element: <OverviewPage /> },
  { path: "projects",                       element: <ProjectsPage /> },
  { path: "projects/:id",                   element: <ProjectDetailPage /> },
  { path: "services",                       element: <ServicesPage /> },
  { path: "services/new",                   element: <AddServiceWizardPage /> },
  { path: "services/:id",                   element: <ServiceDetailPage /> },
  { path: "services/:id/deployments/:deploymentId", element: <DeploymentViewerPage /> },
  { path: "deployments",                    element: <DeploymentsPage /> },
  { path: "containers",                     element: <ContainersPage /> },
  { path: "containers/:serviceId/:podId/:containerName", element: <ContainerDetailPage /> },
  { path: "clusters/:id",                   element: <ClusterOverviewPage /> },
  { path: "clusters/:id/objects",             element: <K8sExplorerPage /> },
  { path: "clusters/:id/topology",          element: <ClusterTopologyPage /> },
  { path: "workspace",                      element: <OperationsWorkspacePage /> },
  { path: "map",                            element: <ServiceMapPage /> },
  { path: "traces",                         element: <TracingPage /> },
  { path: "traces/:id",                     element: <TraceDetailPage /> },
  { path: "logs",                           element: <LogsPage /> },
  { path: "metrics",                        element: <MetricsPage /> },
  { path: "rca",                            element: <RCAPage /> },
  { path: "dependencies",                   element: <DependenciesPage /> },
  { path: "health",                         element: <HealthPage /> },
  { path: "ai",                             element: <AIAssistantPage /> },
  { path: "alerts",                         element: <AlertsPage /> },
  { path: "security",                       element: <SecurityPage /> },
  { path: "profiling",                      element: <ProfilingPage /> },
  { path: "testing",                        element: <TestingPage /> },
  { path: "export",                         element: <ExportPage /> },
  { path: "*",                              element: <NotFoundPage /> },
];

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: <ProtectedRoute><RootLayout /></ProtectedRoute>,
    children: microservicesRoutes,
  },
]);
